import { render, staticRenderFns } from "./receiptDetailList.vue?vue&type=template&id=4dce52c8&scoped=true"
import script from "./receiptDetailList.vue?vue&type=script&lang=js"
export * from "./receiptDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dce52c8",
  null
  
)

export default component.exports